import { render, staticRenderFns } from "./TaskManage.vue?vue&type=template&id=69cc1e71&scoped=true&"
import script from "./TaskManage.vue?vue&type=script&lang=ts&"
export * from "./TaskManage.vue?vue&type=script&lang=ts&"
import style0 from "./TaskManage.vue?vue&type=style&index=0&id=69cc1e71&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc1e71",
  null
  
)

export default component.exports